import styles from "./SummaryCard.module.css";
import { formatDateLong } from "../../utils/time";

interface SummaryCardProps {
  eventDate: string | null;
  startTime: string;
  endTime: string;
  endNextDay: boolean;
  location: string;
  eventTypeLabel: string;
  guestCountLabel?: string;
  customPrintDesignLabel?: string;
}

export function SummaryCard({
  eventDate,
  startTime,
  endTime,
  endNextDay,
  location,
  eventTypeLabel,
  guestCountLabel,
  customPrintDesignLabel,
}: SummaryCardProps) {
  const rows: [string, string][] = [];
  if (eventDate) rows.push(["Datum", formatDateLong(eventDate)]);
  if (startTime || endTime) {
    rows.push([
      "Tijden",
      `${startTime || "?"} - ${endTime || "?"}${endNextDay ? " (volgende dag)" : ""}`,
    ]);
  }
  if (location) rows.push(["Locatie", location]);
  if (eventTypeLabel) rows.push(["Type evenement", eventTypeLabel]);
  if (guestCountLabel) rows.push(["Aantal gasten", guestCountLabel]);
  if (customPrintDesignLabel) rows.push(["Printontwerp", customPrintDesignLabel]);

  return (
    <aside className={styles.card} aria-label="Samenvatting van jouw aanvraag">
      <h2 className={styles.title}>Jouw aanvraag</h2>
      {rows.length === 0 ? (
        <p className={styles.placeholder}>Vul het formulier in om hier een samenvatting te zien.</p>
      ) : (
        <dl className={styles.list}>
          {rows.map(([label, value]) => (
            <div key={label} className={styles.row}>
              <dt>{label}</dt>
              <dd>{value}</dd>
            </div>
          ))}
        </dl>
      )}
    </aside>
  );
}
